import DumbTextFieldAtom from './TextFieldAtom.dumb';

export interface TextFieldAtomI {
    /** Puts the input field in focus if true */
    autoFocus?: boolean;

    /** Controls display of the eye icon button, used to toggle password visibility */
    /** Works together with the field.type, currently only for `text` | `password` */
    canToggleTypeAttribute?: boolean;

    /** When set to true will stops browsers from auto completing the input field */
    disableAutoComplete?: boolean;

    /** Error message to be displayed below each field */
    errorText?: string;

    /** Indicates if an error exists for this field */
    hasError: boolean;

    /** The key from the registration config, to be used as name/id of the field */
    id?: string;

    /** Display label for the field */
    label: string;

    /** What to show when nothing is entered into the field */
    placeholder: string;

    /** Whether the field is required to continue */
    required: boolean;

    /** The type of HTML text input */
    type: string;

    /** Callback to trigger to update the value managed externally */
    updateField: (value: string) => void;

    /** The current value of the field, managed by the form */
    value: string;
}

const TextFieldAtom = ({
    autoFocus,
    canToggleTypeAttribute,
    disableAutoComplete,
    errorText,
    hasError,
    id,
    label,
    placeholder,
    required,
    type,
    updateField,
    value,
}: TextFieldAtomI) => (
    <DumbTextFieldAtom
        autoFocus={autoFocus}
        canToggleTypeAttribute={canToggleTypeAttribute}
        disableAutoComplete={disableAutoComplete}
        errorText={errorText}
        hasError={hasError}
        id={id}
        label={label}
        placeholder={placeholder}
        required={required}
        type={type}
        updateField={updateField}
        value={value}
    />
);

export default TextFieldAtom;
